import { setupHeapAnalytics } from 'config/setup-heap-analytics.js';
import AppRoutes from './AppRoutes';
import { useConfig } from './hooks/UseConfig.ts';

const App = () => {
  const favicon = document.getElementById('favicon');
  const { heapAnalyticsId, stsAuthority } = useConfig();

  setupHeapAnalytics(heapAnalyticsId);

  if (stsAuthority === 'https://shared-identity.stg.kube.network/') {
    favicon?.setAttribute('href', '/favicon-stg.png');
  } else {
    favicon?.setAttribute('href', '/favicon-prd.png');
  }

  return <AppRoutes />;
};

export default App;
